import {API, API_ROUTES} from "../../api";
import router from "../../router";

const auth = {
    namespaced: true,
    state: {
        is_user_logged_in: false,
        user: {},
        token: ''
    },
    mutations: {
        setIsUserLoggedIn(state, value) {
            state.is_user_logged_in = value;
        },
        setUser(state, value) {
            state.user = value;
        },
        setToken(state, value) {
            state.token = value;
        }
    },
    actions: {
        checkAuth({commit, state}) {
            API.get(API_ROUTES.CURRENT_USER).then(({data}) => {
                if (!state.is_user_logged_in) {
                    commit('setIsUserLoggedIn', true);
                }
                //Always set updater user data.
                commit('setUser', data.user);
                //redirect to quasar app.
                if (!data.user.role || data.user.role.code !== 'admin') {
                    window.location.href = process.env.MIX_USER_APP_URL;
                }
            }).catch(({response}) => {
                if (401 === response.status) {
                    commit('setIsUserLoggedIn', false);
                    commit('setUser', {});
                    let currentRoute = router.currentRoute;
                    if (typeof currentRoute.meta.is_auth === 'boolean' && currentRoute.meta.is_auth) {
                        router.replace({name: 'login'});
                    }
                }
            });
        },
        login({commit}, data) {
            commit('setIsUserLoggedIn', true);
            commit('setUser', data.user);
            commit('setToken', data.token);
            //Put token in Axios.
            API.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        },
        logout({commit}) {
            commit('setIsUserLoggedIn', false);
            commit('setUser', {});
            commit('setToken', '');
        }
    },
    getters: {
        hasAdminPermissions(state) {
            return (permissions) => {
                if (state.user.is_super_admin) {
                    return true;
                }
                if (state.user.role.code !== 'admin') {
                    return false;
                }
                if (!Array.isArray(permissions)) {
                    permissions = [permissions]
                }
                for (let i = 0; i < permissions.length; i++) {
                    const code = permissions[i];
                    if (!state.user.admin_permissions.find(p => p.code === code)) {
                        return false;
                    }
                }

                return true;
            }
        }
    }
}

export default auth;
